module.exports = __webpack_public_path__ + "static/mbldc-ee9035f59784472ba68aa5f76c8d0ea5.gif";